module.exports = "https://img.xiyuyouxi.com/saas/img/dataicon3.1dde1349.png";